export const expByLvl = [
    {
        Level: 1,
        NextLvl: 1000,
        TotalExp: 0
    },
    {
        Level: 2,
        NextLvl: 1325,
        TotalExp: 1000
    },
    {
        Level: 3,
        NextLvl: 1700,
        TotalExp: 2325
    },
    {
        Level: 4,
        NextLvl: 2150,
        TotalExp: 4025
    },
    {
        Level: 5,
        NextLvl: 2625,
        TotalExp: 6175
    },
    {
        Level: 6,
        NextLvl: 3150,
        TotalExp: 8800
    },
    {
        Level: 7,
        NextLvl: 3725,
        TotalExp: 11950
    },
    {
        Level: 8,
        NextLvl: 4350,
        TotalExp: 15675
    },
    {
        Level: 9,
        NextLvl: 5000,
        TotalExp: 20025
    },
    {
        Level: 10,
        NextLvl: 5700,
        TotalExp: 25025
    },
    {
        Level: 11,
        NextLvl: 6450,
        TotalExp: 30725
    },
    {
        Level: 12,
        NextLvl: 7225,
        TotalExp: 37175
    },
    {
        Level: 13,
        NextLvl: 8050,
        TotalExp: 44400
    },
    {
        Level: 14,
        NextLvl: 8925,
        TotalExp: 52450
    },
    {
        Level: 15,
        NextLvl: 9825,
        TotalExp: 61375
    },
    {
        Level: 16,
        NextLvl: 10750,
        TotalExp: 71200
    },
    {
        Level: 17,
        NextLvl: 11725,
        TotalExp: 81950
    },
    {
        Level: 18,
        NextLvl: 12725,
        TotalExp: 93675
    },
    {
        Level: 19,
        NextLvl: 13775,
        TotalExp: 106400
    },
    {
        Level: 20,
        NextLvl: 14875,
        TotalExp: 120175
    },
    {
        Level: 21,
        NextLvl: 16800,
        TotalExp: 135050
    },
    {
        Level: 22,
        NextLvl: 18000,
        TotalExp: 151850
    },
    {
        Level: 23,
        NextLvl: 19250,
        TotalExp: 169850
    },
    {
        Level: 24,
        NextLvl: 20550,
        TotalExp: 189100
    },
    {
        Level: 25,
        NextLvl: 21875,
        TotalExp: 209650
    },
    {
        Level: 26,
        NextLvl: 23250,
        TotalExp: 231525
    },
    {
        Level: 27,
        NextLvl: 24650,
        TotalExp: 254775
    },
    {
        Level: 28,
        NextLvl: 26100,
        TotalExp: 279425
    },
    {
        Level: 29,
        NextLvl: 27575,
        TotalExp: 305525
    },
    {
        Level: 30,
        NextLvl: 29100,
        TotalExp: 333100
    },
    {
        Level: 31,
        NextLvl: 30650,
        TotalExp: 362200
    },
    {
        Level: 32,
        NextLvl: 32250,
        TotalExp: 392850
    },
    {
        Level: 33,
        NextLvl: 33875,
        TotalExp: 425100
    },
    {
        Level: 34,
        NextLvl: 35550,
        TotalExp: 458975
    },
    {
        Level: 35,
        NextLvl: 37250,
        TotalExp: 494525
    },
    {
        Level: 36,
        NextLvl: 38975,
        TotalExp: 531775
    },
    {
        Level: 37,
        NextLvl: 40750,
        TotalExp: 570750
    },
    {
        Level: 38,
        NextLvl: 42575,
        TotalExp: 611500
    },
    {
        Level: 39,
        NextLvl: 44425,
        TotalExp: 654075
    },
    {
        Level: 40,
        NextLvl: 46300,
        TotalExp: 698500
    },
    {
        Level: 41,
        NextLvl: 50625,
        TotalExp: 744800
    },
    {
        Level: 42,
        NextLvl: 52700,
        TotalExp: 795425
    },
    {
        Level: 43,
        NextLvl: 54775,
        TotalExp: 848125
    },
    {
        Level: 44,
        NextLvl: 56900,
        TotalExp: 902900
    },
    {
        Level: 45,
        NextLvl: 59075,
        TotalExp: 959800
    },
    {
        Level: 46,
        NextLvl: 61275,
        TotalExp: 1018875
    },
    {
        Level: 47,
        NextLvl: 63525,
        TotalExp: 1080150
    },
    {
        Level: 48,
        NextLvl: 65800,
        TotalExp: 1143675
    },
    {
        Level: 49,
        NextLvl: 68125,
        TotalExp: 1209475
    },
    {
        Level: 50,
        NextLvl: 70475,
        TotalExp: 1277600
    },
    {
        Level: 51,
        NextLvl: 76500,
        TotalExp: 1348075
    },
    {
        Level: 52,
        NextLvl: 79050,
        TotalExp: 1424575
    },
    {
        Level: 53,
        NextLvl: 81650,
        TotalExp: 1503625
    },
    {
        Level: 54,
        NextLvl: 84275,
        TotalExp: 1585275
    },
    {
        Level: 55,
        NextLvl: 86950,
        TotalExp: 1669550
    },
    {
        Level: 56,
        NextLvl: 89650,
        TotalExp: 1756500
    },
    {
        Level: 57,
        NextLvl: 92400,
        TotalExp: 1846150
    },
    {
        Level: 58,
        NextLvl: 95175,
        TotalExp: 1938550
    },
    {
        Level: 59,
        NextLvl: 98000,
        TotalExp: 2033725
    },
    {
        Level: 60,
        NextLvl: 100875,
        TotalExp: 2131725
    },
    {
        Level: 61,
        NextLvl: 108950,
        TotalExp: 2232600
    },
    {
        Level: 62,
        NextLvl: 112050,
        TotalExp: 2341550
    },
    {
        Level: 63,
        NextLvl: 115175,
        TotalExp: 2453600
    },
    {
        Level: 64,
        NextLvl: 118325,
        TotalExp: 2568775
    },
    {
        Level: 65,
        NextLvl: 121525,
        TotalExp: 2687100
    },
    {
        Level: 66,
        NextLvl: 124775,
        TotalExp: 2808625
    },
    {
        Level: 67,
        NextLvl: 128075,
        TotalExp: 2933400
    },
    {
        Level: 68,
        NextLvl: 131400,
        TotalExp: 3061475
    },
    {
        Level: 69,
        NextLvl: 134775,
        TotalExp: 3192875
    },
    {
        Level: 70,
        NextLvl: 138175,
        TotalExp: 3327650
    },
    {
        Level: 71,
        NextLvl: 148700,
        TotalExp: 3465825
    },
    {
        Level: 72,
        NextLvl: 152375,
        TotalExp: 3614525
    },
    {
        Level: 73,
        NextLvl: 156075,
        TotalExp: 3766900
    },
    {
        Level: 74,
        NextLvl: 159825,
        TotalExp: 3922975
    },
    {
        Level: 75,
        NextLvl: 163600,
        TotalExp: 4082800
    },
    {
        Level: 76,
        NextLvl: 167425,
        TotalExp: 4246400
    },
    {
        Level: 77,
        NextLvl: 171300,
        TotalExp: 4413825
    },
    {
        Level: 78,
        NextLvl: 175225,
        TotalExp: 4585125
    },
    {
        Level: 79,
        NextLvl: 179175,
        TotalExp: 4760350
    },
    {
        Level: 80,
        NextLvl: 183175,
        TotalExp: 4939525
    },
    {
        Level: 81,
        NextLvl: 216225,
        TotalExp: 5122700
    },
    {
        Level: 82,
        NextLvl: 243025,
        TotalExp: 5338925
    },
    {
        Level: 83,
        NextLvl: 273100,
        TotalExp: 5581950
    },
    {
        Level: 84,
        NextLvl: 306800,
        TotalExp: 5855050
    },
    {
        Level: 85,
        NextLvl: 344600,
        TotalExp: 6161850
    },
    {
        Level: 86,
        NextLvl: 386950,
        TotalExp: 6506450
    },
    {
        Level: 87,
        NextLvl: 434425,
        TotalExp: 6893400
    },
    {
        Level: 88,
        NextLvl: 487625,
        TotalExp: 7327825
    },
    {
        Level: 89,
        NextLvl: 547200,
        TotalExp: 7815450
    },
    {
        Level: 90,
        NextLvl: null,
        TotalExp: 8362650
    }
]